import { DRAWER_TYPES, MBOOK_GST, strings } from '@constants'
import React from 'react'
import styled, { css } from 'styled-components'
import { useDispatch } from 'react-redux'
import { Edit } from '@material-ui/icons'
import { toggleDrawer } from '@data/state/action/root'
import { Spacings, Text } from '@styles'
import { EditIconWrapper, GSTCard, Value } from '@pages/Admin/OrgsAndUsers/Organisation/styles'



export const AddressCardWrapper = styled(GSTCard)`
	margin-bottom: ${Spacings.SPACING_2B};
	border: 1px solid transparent;
	border-radius: ${Spacings.SPACING_2B};

	${({ hoverable }) => {
		if (hoverable) {
			return css`
				cursor: pointer;
				&:hover {
					border-color: ${({ theme }) => theme.palette.background.blue};
				}
			`
		}
	}}
`

export const Label = styled.span`
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_600};
	color: ${({ theme }) => theme.palette.text.label};
	display: inline-block;
	margin-bottom: ${Spacings.SPACING_2B};
`

const BillingAddress = ({ state2, valueChangeHandler }) => {
	const globalDispatch = useDispatch()

	const getMBookGst = () => {
		return MBOOK_GST
	}

	const updateCallback = (_address) => {
		valueChangeHandler(null, 'billing_address')(_address)
	}

	const editMbookGst = () => {
		globalDispatch(
			toggleDrawer(true, DRAWER_TYPES.EDIT_GST_ADDRESS, {
				label: strings('edit', 'gst'),
				updateCallback,
				addresses: getMBookGst(),
			})
		)
	}

	return (
		<AddressCardWrapper>
			<div>
				<div>
					<Label>Mbook Billing Address</Label>
					<Value>{state2?.enquiryQuote?.billing_address?.gst}</Value>
				</div>
				<div>
					<EditIconWrapper type='secondary' variant='' onClick={editMbookGst}>
						<Edit fontSize='small' />
					</EditIconWrapper>
				</div>
			</div>
			{state2?.enquiryQuote?.billing_address && (
				<div>
					<Label>Billing Address</Label>
					<div>
						<small>
							{state2?.enquiryQuote?.billing_address?.address?.complete_address && (
								<p>{state2?.enquiryQuote?.billing_address?.address?.complete_address}</p>
							)}
						</small>
						{
							<b>
								<small>
									{state2?.enquiryQuote?.billing_address?.address?.city}, {state2?.enquiryQuote?.billing_address?.address?.state} -{' '}
									{state2?.enquiryQuote?.billing_address?.address?.pincode}{' '}
								</small>
							</b>
						}
					</div>
				</div>
			)}
		</AddressCardWrapper>
	)
}

export default BillingAddress
